const SDK_VERSION = "10.72.0" ;

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
